module.exports = __webpack_public_path__ + "tab.svg?a6b3ec3f2a1bf73bf3b39e2d74da37fe";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tab.svg
// module id = 851
// module chunks = 0